module.exports = __webpack_public_path__ + "img/mobileiot2.08e3c21c.png";